import { defineMessages } from 'react-intl';

export const teaserBlockDefaultMessages = defineMessages({
  PleaseChooseContent: {
    id: 'Please choose an existing content as source for this element',
    defaultMessage:
      'Please choose an existing content as source for this element',
  },
});
